import React, { useCallback, useState } from 'react'
import { down } from 'styled-breakpoints'
import styled from 'styled-components'
import { useBreakpoint } from 'styled-breakpoints/react-styled'
import { ReactComponent as Icon1 } from '../../assets/svg/instruction-1.svg'
import { ReactComponent as Icon2 } from '../../assets/svg/instruction-2.svg'
import { ReactComponent as Icon3 } from '../../assets/svg/instruction-3.svg'
import { ReactComponent as Icon4 } from '../../assets/svg/instruction-4.svg'
import { ReactComponent as Icon5 } from '../../assets/svg/instruction-5.svg'

import { MOBILE, TABLET } from '../../lib/constant'
import Card, { CardTemplate } from '../common/Card'
import { Button } from './MainFAQSection'

const data = [
	{
		id: 1,
		title: '헬멧을\n착용하세요.',
		icon: <Icon1 />,
		bgColor: 'green',
		height: 412,
		backTitle: '헬멧을 착용하세요.',
		backDescription:
			'헬멧은 부상의 위험을 크게 줄여 줍니다. 소중한 당신을 보호하세요.',
	},
	{
		id: 2,
		title: '성숙한 주행문화로\n즐겁게 라이딩해요',
		icon: <Icon2 />,
		bgColor: 'yellow',
		height: 412,
		backTitle: '성숙한 주행문화로 즐겁게 라이딩해요.',
		backDescription:
			'주행에 집중하여 사고를 예방하세요. 내리막길을 달릴 때는 속도를 줄이고, 날이 어두울 때는 빛이 반사되는 밝은 옷을 입으세요. ',
	},
	{
		id: 3,
		title: '부드러운 주행,\n부드러운\n브레이크시스템',
		icon: <Icon3 />,
		bgColor: 'red',
		height: 468,
		backTitle: '부드러운 주행, 부드러운 브레이크 시스템',
		backDescription:
			'부드러운 브레이크 시스템으로 더욱더 안전하고 즐거운 주행이 가능합니다.',
	},
	{
		id: 4,
		title: '교통법규를\n반드시 지켜주세요.',
		icon: <Icon4 />,
		bgColor: 'orange',
		height: 412,
		backTitle: '교통 법규를 반드시 지켜주세요.',
		backDescription:
			'자전거 도로는 사고를 90% 줄여 주며, 전방 주행에 집중할 수 있습니다.',
	},
	{
		id: 5,
		title: '꼼꼼한 정비로\n안전성 수시 체크',
		icon: <Icon5 />,
		bgColor: 'pink',
		height: 412,
		backTitle: '꼼꼼한 정비로 안전성 수시 체크',
		backDescription:
			'문제가 발생하면 바로 수거 및 발생하지 않아도 수시로 기기를 체크하며 정비를 꼼꼼하게 진행하고 있습니다.',
	},
]

export default function InstructionSection() {
	const isTablet = useBreakpoint(down(MOBILE))
	const [hidden, setHidden] = useState(true)

	const showMore = useCallback(() => {
		setHidden(false)
	}, [])

	const hideMore = useCallback(() => {
		setHidden(true)
	}, [])

	return (
		<Section>
			<h2>
				자유롭고 안전하게 <br /> 주행하세요.
			</h2>
			<CardList>
				<li>
					{data
						.slice(0, 3)
						.map(
							({
								title,
								bgColor,
								id,
								icon,
								height,
								backTitle,
								backDescription,
							}) => (
								<Card
									title={title}
									bgColor={bgColor}
									id={id}
									icon={icon}
									cardHeight={height}
									key={id}
									backTitle={backTitle}
									backDescription={backDescription}
								/>
							)
						)}
				</li>

				{isTablet ? (
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
						}}
					>
						{hidden ? (
							<Button onClick={showMore}>더보기</Button>
						) : (
							<li className="right-cards">
								{data
									.slice(3, 5)
									.map(
										({
											title,
											bgColor,
											id,
											icon,
											height,
											backTitle,
											backDescription,
										}) => (
											<Card
												title={title}
												bgColor={bgColor}
												id={id}
												icon={icon}
												cardHeight={height}
												key={id}
												backTitle={backTitle}
												backDescription={backDescription}
											/>
										)
									)}
								<LastCard>
									타고가와 함께 <br />
									도심속 라이딩의 <br />
									즐거움을 <br />
									느껴보세요
								</LastCard>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<Button onClick={hideMore}>접기</Button>
								</div>
							</li>
						)}
					</div>
				) : (
					<li className="right-cards">
						{data
							.slice(3, 5)
							.map(
								({
									title,
									bgColor,
									id,
									icon,
									height,
									backTitle,
									backDescription,
								}) => (
									<Card
										title={title}
										bgColor={bgColor}
										id={id}
										icon={icon}
										cardHeight={height}
										key={id}
										backTitle={backTitle}
										backDescription={backDescription}
									/>
								)
							)}
						<LastCard>
							타고가와 함께 <br />
							도심속 라이딩의 <br />
							즐거움을 <br />
							느껴보세요
						</LastCard>
					</li>
				)}
			</CardList>
		</Section>
	)
}

const Section = styled.div`
	max-width: 980px;
	margin: 0 auto;
	overflow-x: hidden;
	margin-top: 196px;

	& > h2 {
		font-size: 96px;
		line-height: 96px;
		font-weight: 700;
		text-align: center;

		${down(TABLET)} {
			font-size: 40px;
			line-height: 48px;
		}
	}

	${down(TABLET)} {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 16px;
	}
`

const CardList = styled.ul`
	margin-top: 64px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
	padding-bottom: 40px;
	width: 100%;

	${down(MOBILE)} {
		display: flex;
		flex-direction: column;
		width: 100%;
		.right-cards {
			margin-top: 20px;
			width: 100%;
		}
	}
`

const LastCard = styled(CardTemplate)`
	font-size: 48px;
	line-height: 56px;
	letter-spacing: -0.02em;
	font-weight: 700;
	max-width: 480px;
	width: 100%;
	height: 468px;
	margin-top: 20px;
	color: #eb4c60;
	display: flex;
	align-items: center;
	cursor: default;
	position: relative;

	${down(TABLET)} {
		max-width: 100%;
	}
`
